var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlovakiaLoto5From35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.431 35.358c1.502 0 2.99-1.466 3.26-2.94l3.894-21.185c.278-1.481-.598-2.584-2.1-2.591H12.637c-1.502 0-3.139 1.096-3.41 2.584L5.412 32.411c-.278 1.474.676 2.94 2.171 2.94l23.847.007z",
    fill: "#ed1c24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.244 18.366c2.677 0 4.926-2.171 5.04-4.862a4.663 4.663 0 0 0-4.698-4.855 5.07 5.07 0 0 0-5.026 4.855c-.093 2.691 2.007 4.862 4.684 4.862",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.308 16.942a3.58 3.58 0 0 0 3.552-3.445 3.294 3.294 0 0 0-3.317-3.431 3.58 3.58 0 0 0-3.552 3.431c-.085 1.915 1.402 3.445 3.317 3.445",
    fill: "#26247b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.447 13.162c.598 0 1.103-.47 1.118-1.075.036-.598-.441-1.082-1.039-1.082s-1.089.484-1.125 1.089a1.044 1.044 0 0 0 1.046 1.068m6.186 5.218H15.834a3.64 3.64 0 0 0-3.645 3.63 3.64 3.64 0 0 0 3.645 3.63h1.516l-1.068 6.051a3.63 3.63 0 0 0 3.638 3.63 3.635 3.635 0 0 0 3.595-3.111l1.21-6.563h3.908a3.63 3.63 0 0 0 3.638-3.63 3.636 3.636 0 0 0-3.638-3.638",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.746 19.804h-4.912a2.21 2.21 0 0 0-2.207 2.207c0 1.21.982 2.2 2.207 2.207l3.232-.028-1.317 7.467a2.21 2.21 0 0 0 2.207 2.207c1.132 0 1.986-.918 2.185-1.943l1.367-7.624c.933-4.577-2.762-4.492-2.762-4.492m7.887 4.441c1.224 0 2.207-1.025 2.207-2.235a2.21 2.21 0 0 0-2.207-2.207H21.65s4.043.384 3.317 4.442h3.666z",
    fill: "#26247b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M-29 21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakiaLoto5From35);
export default __webpack_public_path__ + "static/media/slovakia_loto_5_from_35.ebb2c11aa108fcccdc22f806ec92f44e.svg";
export { ForwardRef as ReactComponent };